<script setup lang="ts">
import type { PortableTextBlock } from 'sanity';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme: string;
    anchorId?: string;
    preTitle?: Array<PortableTextBlock>;
    variant?: string;
    size?: string;
    description?: Array<PortableTextBlock>;
    title?: Array<PortableTextBlock>;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  preTitle: props.block?.preTitle,
  title: props.block?.title,
  variant: props.block?.variant,
  size: props.block?.size,
  description: props.block?.description,
}));

</script>

<template>
  <div class="wrapper wrapper--content" :id="props.block?.anchorId" >
    <component :is="props.config?.innerComponent" v-bind="data" />
  </div>
</template>
